<template>
  <div
    v-if="showAddAdjustment"
    class="rtb-bs m-0 p-10 p-t-20"
  >
    <div
      class="add-adjustment-filter-inputs slide-down m-t-0"
    >
      <!-- Tag selector - START -->
      <!-- TODORTB: Tag selector Mobile Version HERE -->
      <!-- TODORTB: Check validation for this component -->
      <!-- <TagSelector
        v-model="adjustmentTag"
        class="filter-tag-id add-adjustment-tag-selector"
        :tags="availableTags" 
        :form-name="formNameForUserSettings"
        :search-placeholder="$t('SEARCH_FILTER')"
        :placeholder="$t('SELECT_FILTER')"
        :recently-used-tags="recentlyUsedTags"
        empty-tab-placeholder-text="FILTER_SELECTOR_EMPTY_TAB_PLACEHOLDER_TEXT"
        @change="onTagSelected"
      /> -->
      <div
        v-if="showComparisonTag(adjustment)"
        class="add-adjustment-tag-input-group"
      >
        <input
          v-model="adjustmentTagToInput"
          data-cy="input-adjustment-tag-name"
          class="form-control filter-criteria-value add-adjustment-tag-input"
          :placeholder="$t('INPUT_TAG')"
          type="text"
          @input="onTagSelected"
        >
        <RtbMacrosPopover @selected-macro="onSelectedMacro" />
      </div>
      <!-- Tag selector - END -->

      <!-- Tag Comparer - START -->
      <SearchableDropdown
        v-model="adjustmentComparisonType"
        data-cy="select-adjustment-comparison-type"
        class="filter-comparison-type add-adjustment-comparison-type"
        rules="required"
        :config="comparisonOptions"
        :placeholder="$t('ROUTER_TAG_COMPARE_PH')"
        :searchable="false"
        :clearable="false"
        @change="onAdjustmentComparisonType"
      />
      <!-- Tag Comparer - END -->
      <!-- Tag Input - START -->
      <ValidationProvider
        v-if="!allowMultiselect && !inputIsRange && !isBoolean && !autoFillFilterValues"
        :rules="adjustmentComparisonValueValidations"
        slim
      >
        <input
          v-if="showComparisonValue(adjustment)"
          v-model="adjustmentComparisonValue"
          data-cy="input-adjustment-comparison-value"
          class="form-control filter-criteria-value add-adjustment-comparison-input"
          :placeholder="$t('ROUTER_TAG_VALUE_PH')"
          type="text"
        >
      </ValidationProvider>

      <BulkModifiersSelector
        v-if="showBulkSelector(adjustment)"
        class="add-adjustment-comparison-input"
        :selected-bulk-modifier-id="currentAdjustment.bulkListId"
        @selected="onSelectedBulkModifier"
      />

      <ValidationProvider
        v-if="allowMultiselect && !inputIsRange"
        rules="required"
        slim
      >
        <MultiSelect
          v-if="showComparisonValue(adjustment)"
          v-model="adjustmentComparisonValue"
          class="add-adjustment-filter-or-criteria__value multi-select-lg add-adjustment-comparison-input"
          :class="{ 'multi-select-lg': isFullWidth }"
          show-select-all
          :list-items="prefilledValuesForTag"
        />
      </ValidationProvider>

      <!-- <InputMinMax
        v-if="showComparisonValue(adjustment)"
        v-if="inputIsRange"
        v-model="adjustmentComparisonValue"
        hide-label
        hide-form-group
        class-for-input="col-md-6"
        class="add-adjustment-comparison-input"
        :min="0"
        :max="99999999"
       -->
      <!-- Tag Input - END -->

      <!-- Adjustment Operation - START -->
      <SearchableDropdown
        v-if="adjustment.comparisonTypeTemp.value != 'REQUIRED'"
        v-model="adjustmentOperationType"
        data-cy="select-adjustment-operation-type"
        class="filter-comparison-type add-adjustment-operation-type"
        rules="required"
        :config="operationOptions"
        :placeholder="$t('ROUTER_TAG_COMPARE_PH')"
        :searchable="false"
        :clearable="false"
        @change="onAdjustmentOperationType"
      />
      <!-- Adjustment Operation - END -->

      <!-- Adjustment Operation Value - START -->
      <input
        v-if="showOperationValue(adjustment)"
        v-model="adjustmentOperationValue"
        data-cy="input-adjustment-value"
        class="form-control filter-criteria-value add-adjustment-operation-input"
        :placeholder="$t('ROUTER_OPERATION_VALUE_PH')"
        :type="isOperationInputActive ? 'number' : 'text'"
        @focus="isOperationInputActive = true"
        @blur="isOperationInputActive = false"
      >
      <!-- Adjustment Operation Value - END -->

      <!-- Adjustment Operation OverrideFromTag - START -->
      <input
        v-if="showOperationOverrideFromTag(adjustment)"
        v-model="overrideTag"
        class="form-control filter-criteria-value add-adjustment-operation-input"
        :placeholder="$t('OPERATION_OVERRIDE_FROM_TAG_PH')"
        type="text"
        @focus="isOperationInputActive = true"
        @blur="isOperationInputActive = false"
      >
      <!-- Adjustment Operation OverrideFromTag - END -->
    </div>


    <Field
      :label="''"
      :hide-label="false"
    >
      <template #element>
        <div class="btns-add-adjustment">
          <button
            v-t="editAdjustment ? 'UPDATE' : 'ADD'"
            :disabled="!isAdjustmentValid()"
            data-cy="btn-save-adjustment"
            class="btn btn-primary add-adjustment-btn btn-xs m-t-5"
            type="button"
            @click="editAdjustment ? onEditAdjustment(currentRow) : onAddAdjustment()"
          />
      
          <button
            v-t="'CANCEL'"
            class="btn btn-danger btn-xs add-adjustment-btn m-l-10 m-t-5"
            type="button"
            @click="onCancelAddAdjustment" 
          />
        </div>
      </template>
    </Field>
  </div>
</template>

<script>
import { isEqual, get } from 'lodash';
import currencyFormatter from '@/core/filters/formatCurrency.js';
import messages from './locales';
import sharedMessages from '@/core/locales';
//import { mapActions, mapGetters, mapState } from 'vuex';

const CURRENCY_DECIMAL_DIGITS = 2;
const MULTIPLIER_DECIMAL_DIGITS = 3;

const formatCurrency = (number) => {
  return currencyFormatter(number, 'en-US', CURRENCY_DECIMAL_DIGITS);
};

import { camelCaseFormat } from '@/core/filters/camelCaseFormat';
import { rangeComparisonType } from '@/data/filterData';

//import { normalizedFilters, normalizedTags } from '@/mock/mock-reporting-filter-data';
import TagSelector from '@/core/components/TagSelector/TagSelector';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';
import MultiSelect from '@/core/components/MultiSelect/MultiSelect';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import RtbMacrosPopover from './RtbMacrosPopover';

import BulkModifiersSelector from './BulkModifiersSelector';

export default {
  components: { TagSelector, SearchableDropdown, MultiSelect, Field, RtbMacrosPopover, BulkModifiersSelector },
  props: {
    adjustment: {
      type: Object,
      default() {
        return {
          tagId: '',
          bulkListId: '',
          overrideTag: '',
          comparisonTypeTemp: {
            key: 'EQUALS',
            value: 'EQUALS_SINGLE_VALUE',
            isNegativeMatch: false,
            forGeoTags: false,
            forMultipleValues: false,
          },
          comparisonValue: '',
          operationTypeTemp: {
            key: 'ADD',
            value: 'ADD'
          },
          operationValue: ''
        };
      }
    },
    formNameForUserSettings:{
      type: Array,
      default() {
        return ['Form Name', 'FormName'];
      }
    },
    availableTags: {
      type: Array,
      default() {
        return [];
      }
    },
    valuesForFilter: {
      type: Object,
      default() {
        return {};
      }
    },
    recentlyUsedTags: {
      type: Array,
      default() {
        return [];
      }
    },
    comparisonTypes: {
      type: Array,
      default() { 
        return [];
      }
    },
    operationTypes: {
      type: Array,
      default() { 
        return [];
      }
    },
    showAddAdjustment: {
      type: Boolean,
      default() {
        return true;
      }
    },
    editAdjustment: {
      type: Boolean,
      default() {
        return false;
      }
    },
    currentRow: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return{
      currentAdjustment: this.adjustment,
      autoFillFilterValues: undefined,
      isOperationInputActive: false,
    };
  },
  computed: {
    autoCompleteValuesDropdownConfig() {
      if (!this.autoFillFilterValues) {
        return {};
      }

      return {
        options: this[this.autoFillFilterValues.listMapping],
        placeholder: 'Select',
        reduce: option => get(option, this.autoFillFilterValues.attribute),
        label: this.autoFillFilterValues.displayAttribute
      };
    },
    prefilledValuesForTag() {
      if (this.adjustmentTag?.fieldName) {
        return this.valuesForFilter[this.adjustmentTag.fieldName] || [];
      }

      return [];
    },
    inputIsRange() {
      return this.adjustmentTag?.isRange;
    },
    allowMultiselect() {
      return this.currentAdjustment.comparisonTypeTemp.forMultipleValues == true;
    },
    tagsOptions() {
      return {
        options: this.availableTags,
        placeholder: this.$t('ROUTER_TAG_SELECT_PH'),
        getOptionLabel: function getTagOptionLabel(option) {
          return option && `${camelCaseFormat(option.tagSource)} - ${camelCaseFormat(option.tagType)} - ${camelCaseFormat(option.tagName)}`;
        },
        clearable: false
      };
    },
    comparisonOptions() {
      return {
        options: this.adjustmentTag?.isRange ? [...rangeComparisonType] : this.comparisonTypes,
        placeholder: this.$t('ROUTER_TAG_SELECT_PH'),
        getOptionKey: function getComparisonOptionKey(option) {
          return option.value;
        },
        getOptionLabel: function getOptionLabel(option) {
          return option && camelCaseFormat(option.value);
        },
        clearable: false
      };
    },
    operationOptions() {
      return {
        options: this.operationTypes,
        placeholder: this.$t('ROUTER_TAG_SELECT_PH'),
        getOptionKey: function getComparisonOptionKey(option) {
          return option.value;
        },
        getOptionLabel: function getOptionLabel(option) {
          return option && camelCaseFormat(option.value);
        },
        clearable: false
      };
    },
    adjustmentComparisonValueValidations() {
      let validations = 'required';

      if (this.adjustmentComparisonType.useNumericalValue) {
        validations += '|numeric';
      }

      return validations;
    },
    isBoolean() {
      return this.adjustmentTag?.fieldType === 'boolean';
    },
    // TODO: remove adjustmentTagToInput when we get back to search
    adjustmentTagToInput: {
      get() {
        if (this.currentAdjustment.tagId) {
          // var tagInAvailableTags = this.availableTags.find(tag => this.getTagId(tag) === tagId);

          // if(tagInAvailableTags){
          //   return this.getTagId(tagInAvailableTags);
          // }

          return this.currentAdjustment.tagId;
        }
        return null;
      },
      set(tag) {
        // TODO: uncomment when we get back to search
        // this.currentAdjustment.filterField = tag.isTag ? this.getTagId(tag, 'tag:') : tag.fieldName;
        // this.currentAdjustment.tagId = this.getTagId(tag);
        this.currentAdjustment.tagId = tag;
        this.handleCurrentAdjustmentChange();
      }
    },
    adjustmentTag: {
      get() {
        if (this.currentAdjustment.tagId) {
          const tagId = this.currentAdjustment.tagId;

          // TODO: remove the call to getTagId when we get back to search
          // return this.getTagId(this.availableTags.find(tag => this.getTagId(tag) === tagId));
          return this.availableTags.find(tag => this.getTagId(tag) === tagId);
        }
        return null;
      },
      set(tag) {
        // TODO: uncomment next 2 lines and remove the rest when we get back to search
        // this.currentAdjustment.filterField = tag.isTag ? this.getTagId(tag, 'tag:') : tag.fieldName;
        // this.currentAdjustment.tagId = this.getTagId(tag);
        var tagProps = tag.split(':');
        var newTag = {
          tagType: tagProps[0],
          tagName: tagProps[1],
        };
        this.currentAdjustment.tagId = this.getTagId(newTag);
        this.handleCurrentAdjustmentChange();
      }
    },
    adjustmentComparisonType: {
      get() {
        return this.currentAdjustment.comparisonTypeTemp;
      },
      set(value) { 
        this.currentAdjustment.comparisonTypeTemp = value;
        this.handleCurrentAdjustmentChange();
      }
    },
    adjustmentComparisonValue: {
      get() {
        return this.currentAdjustment.comparisonValue;
      },
      set(value) { 
        this.currentAdjustment.comparisonValue = value;
        this.handleCurrentAdjustmentChange();
      }
    },
    adjustmentOperationType: {
      get() {
        if (this.currentAdjustment.operationValue < 0 && this.currentAdjustment.operationTypeTemp.value == 'Add') {
          this.currentAdjustment.operationTypeTemp.value = 'Subtract';
        }
        return this.currentAdjustment.operationTypeTemp; 
      },
      set(value) {
        if (value.value.toLowerCase() === 'multiply') {
          this.currentAdjustment.operationValue = this.currentAdjustment.operationValue.replace(/[^\d\.\-]/g, '');
          this.currentAdjustment.operationTypeTemp = value;
          this.handleCurrentAdjustmentChange();
          return;
        }
        
        if (value.value.toLowerCase() === 'reject') {
          this.adjustmentOperationValue = 0;
          this.currentAdjustment.operationValue = 0;
        }

        this.currentAdjustment.operationTypeTemp = value;
        this.currentAdjustment.operationValue = this.formatAsCurrency(this.currentAdjustment.operationValue);
        this.handleCurrentAdjustmentChange();
      }
    },
    adjustmentOperationValue: {
      get() {
        if (this.isOperationInputActive) {
          if (this.currentAdjustment.operationTypeTemp.value.toLowerCase() === 'add' || this.currentAdjustment.operationTypeTemp.value.toLowerCase() === 'subtract') {
            // Cursor is inside the input field. unformat display value for user
            this.currentAdjustment.operationValue = this.currentAdjustment.operationValue.replace(/[^\d\.]/g, '');
          } else {
            this.currentAdjustment.operationValue = this.currentAdjustment.operationValue.replace(/[^\d\.\-]/g, '');
          }
        }
        return this.currentAdjustment.operationValue;
      },
      set(value) {
        this.currentAdjustment.operationValue = value;
      }
    },
    bulkListId: {
      get() {
        return this.currentAdjustment.bulkListIdTemp;
      },
      set(value) { 
        this.currentAdjustment.bulkListIdTemp = value;
        this.handleCurrentAdjustmentChange();
      }
    },
    overrideTag: {
      get() {
        return this.currentAdjustment.overrideTag;
      },
      set(value) { 
        this.currentAdjustment.overrideTag = value;
        this.handleCurrentAdjustmentChange();
      }
    },
  },
  watch: {
    adjustment: {
      immediate: true,
      handler(newValue, oldValue) {
        if(!isEqual(newValue, oldValue)) {
          this.currentAdjustment = newValue;
        }
      }
    },
    isSummaryView() {
      this.isEditView = !this.isSummaryView;
    },
    isOperationInputActive:{
      immediate: true,
      handler(newValue) {
        if(newValue == false && this.adjustmentOperationType.value.toLowerCase() !== 'multiply') {
          this.currentAdjustment.operationValue = (this.currentAdjustment.operationValue < 0 ? '-' : '') + this.formatAsCurrency(this.currentAdjustment.operationValue);
          this.handleCurrentAdjustmentChange();
        } else if (newValue == false) {
          const newOperationValue = this.currentAdjustment.operationValue;
          this.currentAdjustment.operationValue = parseFloat(newOperationValue).toFixed(MULTIPLIER_DECIMAL_DIGITS);
        }
      }
    }
  },
  mounted() {
    this.$el.scrollIntoView({behavior: 'smooth', block: 'center'});
    //this.getRecentlyUsedTags(this.formNameForUserSettings);

  },
  methods:{
    // ...mapActions('reporting', [
    //   'getAutoCompleteValues'
    // ]),
    // ...mapActions([
    //   'getRecentlyUsedTags',
    //   'setRecentlyUsedTags'
    // ]),
    getTagOptionLabel(option) {
      return option && `${camelCaseFormat(option.tagSource)} - ${camelCaseFormat(option.tagType)} - ${camelCaseFormat(option.tagName)}`;
    },
    change(values) {
      this.$emit('change', values);
    },
    getTagId(tag, prefix = '') {
      return prefix + tag.tagType + ':' + tag.tagName;
    },
    formatAsCurrency(value) {
      let newOperationValue = value;
      // Recalculate value after ignoring "$" and "," in user input
      newOperationValue = newOperationValue ? parseFloat(newOperationValue.replace(/[^\d\.]/g, '')) : '';

      return typeof newOperationValue === 'number' ? formatCurrency(newOperationValue) : '';
    },
    handleCurrentAdjustmentChange() {
      this.$emit('change', this.currentAdjustment);
    },
    onTagSelected(tag) {
      // this.setRecentlyUsedTags({ 
      //   formName: this.formNameForUserSettings, 
      //   tag 
      // });

      this.onTagIdChange();

      //analyticsMixinFactory?
      //this.trackEvent(FILTER_FIELD_SELECTED_ACTION, `Field:${this.currentAdjustment.tagId}`, this.eventCategory);
    },
    onSelectedMacro(macro) {
      this.adjustmentTagToInput = (this.adjustmentTagToInput? this.adjustmentTagToInput: '')  + macro.displayName;
    },

    onSelectedBulkModifier(bulkModifierId) {
      this.currentAdjustment.bulkListId = bulkModifierId;
      this.handleCurrentAdjustmentChange();
    },

    onTagIdChange() {
      if (this.allowMultiselect) {
        this.adjustmentComparisonValue = [];
      } else if (this.inputIsRange) {
        this.adjustmentComparisonType = {...rangeComparisonType[0]};
        this.adjustmentComparisonValue = {};
      } else {
        this.adjustmentComparisonValue = this.adjustmentComparisonValue ? this.adjustmentComparisonValue : '';
      }

      this.handleCurrentAdjustmentChange();
    },
    onAdjustmentComparisonType(val) {
      this.adjustmentComparisonType = val;
    },
    onAdjustmentOperationType(val) {
      this.adjustmentOperationType = val;
    },
    onAddAdjustment(){
      var newAdjustment = {
        tag: this.currentAdjustment.tagId,
        comparer: this.currentAdjustment.comparisonTypeTemp.value,
        compValue: this.currentAdjustment.comparisonValue,
        operation: this.currentAdjustment.operationTypeTemp.value,
        opValue: this.currentAdjustment.operationValue.replace('$', ''),
        bulkListId: this.currentAdjustment.bulkListId,
        overrideTag: this.currentAdjustment.overrideTag,
      };

      this.$emit('onAddAdjustment', newAdjustment);
      this.$emit('onShowAddAdjustmentChange', !this.showAddAdjustment);
    },
    onEditAdjustment(currentRow){
      var newAdjustment = {
        id: currentRow.id,
        priority: currentRow.priority,
        // TODO: remove the next line when we get back to search
        tag: this.currentAdjustment.tagId,
        // TODO: uncomment the next line when we get back to search
        //tag: this.getTagOptionLabel(this.availableTags.find(tag => this.getTagId(tag) === this.currentAdjustment.tagId)),
        comparer: camelCaseFormat(this.currentAdjustment.comparisonTypeTemp.value),
        compValue: this.currentAdjustment.comparisonValue,
        operation: camelCaseFormat(this.currentAdjustment.operationTypeTemp.value),
        opValue: this.currentAdjustment.operationValue.replace('$', ''),
        bulkListId: this.currentAdjustment.bulkListId,
        overrideTag: this.currentAdjustment.overrideTag,
      };

      this.$emit('onEditAdjustment', newAdjustment);
      this.$emit('onShowAddAdjustmentChange', !this.showAddAdjustment);
    },
    onCancelAddAdjustment(){
      this.$emit('onShowAddAdjustmentChange', !this.showAddAdjustment);
    },
    isAdjustmentValid() {
      return !this.isAdjustmentIncomplete()
          || this.isComparisonTypeRequired()
          || this.isComparisonTypeNotSetOrBulk();
    },
    isAdjustmentIncomplete() {
      // TODO: replace adjustmentTagToInput for adjustmentTag when we get back to search
      const comparisonType = this.adjustmentComparisonType ? this.adjustmentComparisonType.value : null;
      const comparisonTagRequired = this.showComparisonTagByComparisonType(comparisonType);
      const comparisonValueRequired = this.showComparisonValueByComparisonType(comparisonType);

      const operationType = this.adjustmentOperationType ? this.adjustmentOperationType.value : null;
      const operationValueRequired = this.showOperationValueFromSettings(comparisonType, operationType);

      return (!this.adjustmentTagToInput && comparisonTagRequired)
          || !this.adjustmentComparisonType
          || ( !this.adjustmentComparisonValue && comparisonValueRequired ) 
          || !operationType 
          || operationType == ''
          || !this.adjustmentOperationValue && operationValueRequired;
    },
    isComparisonTypeRequired() {
      // TODO: replace adjustmentTagToInput for adjustmentTag when we get back to search
      return !!this.adjustmentTagToInput
          && this.adjustmentComparisonType.value == 'REQUIRED';
    },
    isComparisonTypeNotSetOrBulk() {
      // TODO: replace adjustmentTagToInput for adjustmentTag when we get back to search
      return !!this.adjustmentTagToInput 
          && (this.adjustmentComparisonType.value == 'HAS_NO_VALUE'
           || this.adjustmentComparisonType.value == 'Has No Value'
           || this.adjustmentComparisonType.value != 'BULK'
           || this.adjustmentComparisonType.value != 'Bulk') 
          && !!this.adjustmentOperationType
          && (!!this.adjustmentOperationValue
           || this.adjustmentOperationType.value == 'REJECT');
    },
    showComparisonValue(adjustment){
      return this.showComparisonValueByComparisonType(adjustment.comparisonTypeTemp.value);
    },
    showComparisonValueByComparisonType(compType){
      return compType != 'REQUIRED' 
          && compType != 'Required'

          && compType != 'HAS_NO_VALUE'
          && compType != 'Has No Value'

          && compType != 'ALWAYS'
          && compType != 'Always'

          && compType != 'IS_NUMBER'
          && compType != 'Is Number'

          && compType != 'IS_NOT_NUMBER'
          && compType != 'Is Not Number'

          && compType != 'HAS_VALUE'
          && compType != 'Has Value'

          && compType != 'BULK'
          && compType != 'Bulk';
    },
    showBulkSelector(adjustment) {
      return adjustment.comparisonTypeTemp.value == 'BULK'
          || adjustment.comparisonTypeTemp.value == 'Bulk';
    },
    showOperationValue(adjustment){
      return this.showOperationValueFromSettings(adjustment.comparisonTypeTemp.value, adjustment.operationTypeTemp.value);
    },
    showOperationValueFromSettings(compType, opType){
      return compType != 'REQUIRED'
          && compType != 'Required'
          && opType != 'REJECT'
          && opType != 'Reject'
          && opType != 'OVERRIDE_FROM_TAG'
          && opType != 'OverrideFromTag'
          && opType != 'Override From Tag';
    },
    showOperationOverrideFromTag(adjustment){
      return adjustment.operationTypeTemp.value == 'OVERRIDE_FROM_TAG'
        || adjustment.operationTypeTemp.value == 'Override From Tag'
        || adjustment.operationTypeTemp.value == 'OverrideFromTag'
      ;
    },
    showComparisonTag(adjustment){
      return this.showComparisonTagByComparisonType(adjustment.comparisonTypeTemp.value);
    },
    showComparisonTagByComparisonType(compType){
      return compType != 'ALWAYS'
        && compType != 'Always'
      ;
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss">
  .rtb-bs { 
    background: var(--component-table__form-row); 
    .vs__selected {
      height: 32px;
    }
  }
</style>